import { Component, Input, ChangeDetectionStrategy, HostListener } from '@angular/core';

@Component({
	selector: 'leo-info',
	templateUrl: "./leo-info.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	styles: [require("./leo-info.scss")]
})

export class LeoInfo {
	showPopup: boolean = false;
	@Input() bindPopup: boolean;
	@Input() tooltipText: string;

	showInfoPopup(): void {
		this.showPopup = true;
	}

	closeInfoPopup(): void {
		this.showPopup = false;
	}

	showPopupIfInfoWithPopup(): void {
		if (this.bindPopup) {
			this.showInfoPopup();
		} else {
			return;
		}
	}

	@HostListener('click', ['$event'])
	onLeoInfoClick(event: any) {
		event.preventDefault();
	}
}



// WEBPACK FOOTER //
// ./src/app/ui-helper/leo-info/leo-info.component.ts